module.exports = __webpack_public_path__ + "img/franchising_terms_icon3.7b3ef146.svg";